/**
 * Botón flotante de WhatsApp para el flujo público del titular.
 *
 * Vive durante todo el onboarding (DNI → método → OTP → wizard → cierre):
 * se monta en las rutas públicas (`/` y `/activar/:token`). Es `position:fixed`
 * (esquina inferior derecha), así que flota sobre cualquier paso sin importar
 * el layout. Los estilos `.ms-wa` están en `styles/globals.css`.
 */
const WHATSAPP_HREF =
  'https://api.whatsapp.com/send/?phone=5491123935555&text=Hola%2C%20necesito%20ayuda%20con%20mi%20plan&type=phone_number&app_absent=0';

export function WhatsAppFab() {
  return (
    <a
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener"
      className="ms-wa"
      aria-label="Escribinos por WhatsApp"
    >
      <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
        <path d="M16.04 4C9.96 4 5.02 8.94 5.02 15.02c0 1.94.51 3.83 1.48 5.5L4.9 27l6.65-1.74a11 11 0 0 0 4.49.96h.01c6.08 0 11.02-4.94 11.02-11.02C27.07 8.94 22.12 4 16.04 4Zm0 20.18h-.01a9.13 9.13 0 0 1-4.65-1.27l-.33-.2-3.95 1.03 1.05-3.85-.22-.34a9.1 9.1 0 0 1-1.4-4.86c0-5.05 4.11-9.16 9.17-9.16 2.45 0 4.75.96 6.48 2.69a9.1 9.1 0 0 1 2.68 6.48c0 5.06-4.11 9.17-9.16 9.17Zm5.03-6.86c-.28-.14-1.63-.8-1.88-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.59.07-.28-.14-1.16-.43-2.21-1.36-.82-.73-1.37-1.63-1.53-1.9-.16-.28-.02-.43.12-.57.13-.13.28-.32.41-.48.14-.16.18-.28.28-.46.09-.18.05-.34-.02-.48-.07-.14-.61-1.48-.84-2.02-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.28-.96.94-.96 2.29 0 1.35.98 2.65 1.12 2.83.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.73.11.53-.08 1.63-.67 1.86-1.31.23-.64.23-1.19.16-1.31-.07-.11-.25-.18-.53-.32Z" />
      </svg>
    </a>
  );
}
